// ********************** MENU **********************

const MENU_PROJECT = { name: "Menu Project" }
exports.MENU_PROJECT = MENU_PROJECT;

const MENU_EDIT_PROJECT = { name: "Menu Edit Project", includes: [MENU_PROJECT] }
exports.MENU_EDIT_PROJECT = MENU_EDIT_PROJECT;

const MENU_MANAGE_TEAM = { name: "Menu Manage Team", includes: [MENU_EDIT_PROJECT] }
exports.MENU_MANAGE_TEAM = MENU_MANAGE_TEAM;

const MENU_RESOURCES = { name: "Menu Resources", includes: [MENU_PROJECT] }
exports.MENU_RESOURCES = MENU_RESOURCES;

const MENU_RESOURCE = { name: "Menu Resource", includes: [MENU_RESOURCES] }
exports.MENU_RESOURCE = MENU_RESOURCE;

const MENU_SUBSCRIPTION_PLANS = { name: "Menu Subscription Plans", includes: [MENU_PROJECT] }
exports.MENU_SUBSCRIPTION_PLANS = MENU_SUBSCRIPTION_PLANS;

const MENU_SUBSCRIPTION_PLAN = { name: "Menu Subscription Plan", includes: [MENU_SUBSCRIPTION_PLANS] }
exports.MENU_SUBSCRIPTION_PLAN = MENU_SUBSCRIPTION_PLAN;

const MENU_PAYMENT_OPTIONS = { name: "Menu Payment options", includes: [MENU_PROJECT] }
exports.MENU_PAYMENT_OPTIONS = MENU_PAYMENT_OPTIONS;

const MENU_PAYMENT_OPTION_STRIPE = { name: "Menu Stripe", includes: [MENU_PAYMENT_OPTIONS] }
exports.MENU_PAYMENT_OPTION_STRIPE = MENU_PAYMENT_OPTION_STRIPE;

const MENU_PAYMENT_OPTION_PAYPAL = { name: "Menu PayPal", includes: [MENU_PAYMENT_OPTIONS] }
exports.MENU_PAYMENT_OPTION_PAYPAL = MENU_PAYMENT_OPTION_PAYPAL;

const MENU_PAYMENT_OPTION_COINPAYMENTS= { name: "Menu Coinpayments", includes: [MENU_PAYMENT_OPTIONS] }
exports.MENU_PAYMENT_OPTION_COINPAYMENTS = MENU_PAYMENT_OPTION_COINPAYMENTS;

const MENU_ACCESS_CODES = { name: "Menu Access Codes", includes: [MENU_PAYMENT_OPTIONS] }
exports.MENU_ACCESS_CODES = MENU_ACCESS_CODES;

const MENU_TELEGRAM_BOT = { name: "Menu Telegram Bot", includes: [MENU_PROJECT] }
exports.MENU_TELEGRAM_BOT = MENU_TELEGRAM_BOT;

const MENU_WEBSITE = { name: "Menu Website", includes: [MENU_PROJECT] }
exports.MENU_WEBSITE = MENU_WEBSITE;

const MENU_AFFILIATE_PROGRAM = { name: "Menu Affiliate Program", includes: [MENU_PROJECT] }
exports.MENU_AFFILIATE_PROGRAM = MENU_AFFILIATE_PROGRAM;

const MENU_AFFILIATE_PROGRAM_PAYOUTS = { name: "Menu Affiliate Program Payouts",  includes: [MENU_AFFILIATE_PROGRAM] }
exports.MENU_AFFILIATE_PROGRAM_PAYOUTS = MENU_AFFILIATE_PROGRAM_PAYOUTS;

// ********************** ACTIONS, CALLBACKS **********************

const EDIT_PROJECT = { name: "Edit Project", includes: [MENU_EDIT_PROJECT] };
exports.EDIT_PROJECT = EDIT_PROJECT;

const TRANSFER_PROJECT = { name: "Transfer Project", includes: [MENU_EDIT_PROJECT] }
exports.TRANSFER_PROJECT = TRANSFER_PROJECT;

const DELETE_PROJECT = { name: "Delete Project", includes: [MENU_EDIT_PROJECT] }
exports.DELETE_PROJECT = DELETE_PROJECT;

const ADD_RESOURCES = { name: "Add Resources", includes: [MENU_RESOURCES] }
exports.ADD_RESOURCES = ADD_RESOURCES;

const EDIT_RESOURCES = { name: "Edit Resources", includes: [MENU_RESOURCES]  }
exports.EDIT_RESOURCES = EDIT_RESOURCES;

const DELETE_RESOURCES = { name: "Delete Resources", includes: [MENU_RESOURCES] }
exports.DELETE_RESOURCES = DELETE_RESOURCES;

const MANAGE_RESOURCES = { name: "Manage Resources", includes: [ADD_RESOURCES, EDIT_RESOURCES, DELETE_RESOURCES] }
exports.MANAGE_RESOURCES = MANAGE_RESOURCES;

const CREATE_SUBSCRIPTION_PLANS = { name: "Create Subscription Plans", includes: [MENU_SUBSCRIPTION_PLANS, MENU_SUBSCRIPTION_PLAN] }
exports.CREATE_SUBSCRIPTION_PLANS = CREATE_SUBSCRIPTION_PLANS;

const EDIT_SUBSCRIPTION_PLANS = { name: "Edit Subscription Plans", includes: [MENU_SUBSCRIPTION_PLANS, MENU_SUBSCRIPTION_PLAN] }
exports.EDIT_SUBSCRIPTION_PLANS = EDIT_SUBSCRIPTION_PLANS;

const DELETE_SUBSCRIPTION_PLANS = { name: "Delete Subscription Plans", includes: [MENU_SUBSCRIPTION_PLANS, MENU_SUBSCRIPTION_PLAN] }
exports.DELETE_SUBSCRIPTION_PLANS = DELETE_SUBSCRIPTION_PLANS;

const MANAGE_SUBSCRIPTION_PLANS = { name: "Manage Subscription Plans", includes: [CREATE_SUBSCRIPTION_PLANS, EDIT_SUBSCRIPTION_PLANS, DELETE_SUBSCRIPTION_PLANS] }
exports.MANAGE_SUBSCRIPTION_PLANS = MANAGE_SUBSCRIPTION_PLANS;

const MANAGE_PAYMENT_OPTIONS = { name: "Manage Payment Options", includes: [MENU_PAYMENT_OPTIONS] }
exports.MANAGE_PAYMENT_OPTIONS = MANAGE_PAYMENT_OPTIONS;

const NEW_ACCESS_CODES = { name: "New Access Codes", includes: [MENU_ACCESS_CODES] }
exports.NEW_ACCESS_CODES = NEW_ACCESS_CODES;

const ROLLBACK_ACCESS_CODES = { name: "Rollback Access Codes", includes: [MENU_ACCESS_CODES] }
exports.ROLLBACK_ACCESS_CODES = ROLLBACK_ACCESS_CODES;

const MANAGE_ACCESS_CODES = { name: "Manage Access Codes", includes: [NEW_ACCESS_CODES, ROLLBACK_ACCESS_CODES] }
exports.MANAGE_ACCESS_CODES = MANAGE_ACCESS_CODES;

const BOT_BROADCAST = { name: "Bot Broadcast" }
exports.BOT_BROADCAST = BOT_BROADCAST;

const CHANGE_BOT_LANGUAGE = { name: "Change Bot Language", includes: [MENU_TELEGRAM_BOT] }
exports.CHANGE_BOT_LANGUAGE = CHANGE_BOT_LANGUAGE;

const MANAGE_BOT_COMMANDS = { name: "Manage Bot Commands", includes: [MENU_TELEGRAM_BOT] }
exports.MANAGE_BOT_COMMANDS = MANAGE_BOT_COMMANDS;

const CHANGE_BOT_TOKEN = { name: "Change Bot Token", includes: [MENU_TELEGRAM_BOT] }
exports.CHANGE_BOT_TOKEN = CHANGE_BOT_TOKEN;

const BAN_USERS = { name: "Ban Users" }
exports.BAN_USERS = BAN_USERS;

const UNBAN_USERS = { name: "Unban Users" }
exports.UNBAN_USERS = UNBAN_USERS;

const WHITELIST_USERS = { name: "Whitelist Users" }
exports.WHITELIST_USERS = WHITELIST_USERS;

const UNWHITELIST_USERS = { name: "Unwhitelist Users" }
exports.UNWHITELIST_USERS = UNWHITELIST_USERS;

const EDIT_PAYMENT_DATES = { name: "Edit Payment Dates" }
exports.EDIT_PAYMENT_DATES = EDIT_PAYMENT_DATES;

const USER_STATUS_BY_ID = { name: "User Status By ID" }
exports.USER_STATUS_BY_ID = USER_STATUS_BY_ID;

const USER_DATA = { name: "User Data", includes: [MENU_TELEGRAM_BOT] }
exports.USER_DATA = USER_DATA;

const AFP_EDIT_DESCRIPTION = { name: "Edit Affiliate Program Description", includes: [MENU_AFFILIATE_PROGRAM] }
exports.AFP_EDIT_DESCRIPTION = AFP_EDIT_DESCRIPTION;

const AFP_EDIT_SETTINGS = { name: "Edit Affiliate Program Settings", includes: [MENU_AFFILIATE_PROGRAM] }
exports.AFP_EDIT_SETTINGS = AFP_EDIT_SETTINGS;

const AFP_DATA = { name: "Affiliate Program Data", includes: [MENU_AFFILIATE_PROGRAM, MENU_AFFILIATE_PROGRAM_PAYOUTS] }
exports.AFP_DATA = AFP_DATA;

const AFP_CREATE_PAYOUTS = { name: "Create Affiliate Program Payouts", includes: [MENU_AFFILIATE_PROGRAM_PAYOUTS] }
exports.AFP_CREATE_PAYOUTS = AFP_CREATE_PAYOUTS;

const AFP_CANCEL_PAYOUTS = { name: "Cancel Affiliate Program Payouts", includes: [MENU_AFFILIATE_PROGRAM_PAYOUTS] }
exports.AFP_CANCEL_PAYOUTS = AFP_CANCEL_PAYOUTS;

const AFP_EXECUTE_PAYOUTS = { name: "Execute Affiliate Program Payouts", includes: [MENU_AFFILIATE_PROGRAM_PAYOUTS] }
exports.AFP_EXECUTE_PAYOUTS = AFP_EXECUTE_PAYOUTS;

const AFP_SET_AFFILIATE = { name: "Set Affiliates Manually" }
exports.AFP_SET_AFFILIATE = AFP_SET_AFFILIATE;

const MANAGE_AFP = { name: "Manage Affiliate Program", includes: [AFP_EDIT_DESCRIPTION, AFP_EDIT_SETTINGS, AFP_CREATE_PAYOUTS, AFP_CANCEL_PAYOUTS, AFP_EXECUTE_PAYOUTS, AFP_SET_AFFILIATE ]}
exports.MANAGE_AFP = MANAGE_AFP;

const ACCESS_CODE_MANAGER = { name: "Access Code Manager", includes: [
        MANAGE_ACCESS_CODES
    ]
}
exports.ACCESS_CODE_MANAGER = ACCESS_CODE_MANAGER;

const AFP_MANAGER = { name: "Affiliate Program Manager", includes: [
        MANAGE_AFP
    ]
}
exports.AFP_MANAGER = AFP_MANAGER;

const MANAGER = { name: "Manager", includes: [
        EDIT_PROJECT,
        MANAGE_RESOURCES,
        MANAGE_SUBSCRIPTION_PLANS,
        MANAGE_BOT_COMMANDS,
        MANAGE_ACCESS_CODES,
        AFP_MANAGER
    ]
}
exports.MANAGER = MANAGER;

const ADMINISTRATOR = { name: "Administrator", includes: [
        MANAGER,
        MANAGE_PAYMENT_OPTIONS,
        USER_STATUS_BY_ID,
        USER_DATA,
        AFP_DATA,
        BAN_USERS,
        UNBAN_USERS,
        WHITELIST_USERS,
        UNWHITELIST_USERS
    ]
}
exports.ADMINISTRATOR = ADMINISTRATOR;

// IMPORTANT! Needed for unpackPermission to work
for (let permission in exports) {
    exports[permission].key = permission;
}

// *****************************************************************************

const buildErrorClass = (name) => {
    function NewErrorClass (message) {
        let error = Error.call(this, message);
        this.name = name;
        this.message = error.message;
        this.stack = error.stack;
    }
    NewErrorClass.prototype = Object.create(Error.prototype);
    NewErrorClass.prototype.constructor = NewErrorClass;
    return NewErrorClass;
}

const ProjectAccessDeniedError = buildErrorClass("ProjectAccessDeniedError");
exports.ProjectAccessDeniedError = ProjectAccessDeniedError;

// *****************************************************************************

exports.assignableRoles = [
    ACCESS_CODE_MANAGER,
    AFP_MANAGER,
    MANAGER,
    ADMINISTRATOR
];

exports.assignablePermissions = [
    EDIT_PROJECT,
    TRANSFER_PROJECT,
    DELETE_PROJECT,
    ADD_RESOURCES,
    EDIT_RESOURCES,
    DELETE_RESOURCES,
    MANAGE_RESOURCES,
    CREATE_SUBSCRIPTION_PLANS,
    EDIT_SUBSCRIPTION_PLANS,
    DELETE_SUBSCRIPTION_PLANS,
    MANAGE_SUBSCRIPTION_PLANS,
    MANAGE_PAYMENT_OPTIONS,
    NEW_ACCESS_CODES,
    ROLLBACK_ACCESS_CODES,
    MANAGE_ACCESS_CODES,
    BOT_BROADCAST,
    CHANGE_BOT_LANGUAGE,
    MANAGE_BOT_COMMANDS,
    CHANGE_BOT_TOKEN,
    USER_STATUS_BY_ID,
    USER_DATA,
    AFP_EDIT_DESCRIPTION,
    AFP_EDIT_SETTINGS,
    AFP_CREATE_PAYOUTS,
    AFP_CANCEL_PAYOUTS,
    AFP_EXECUTE_PAYOUTS,
    AFP_DATA,
    AFP_SET_AFFILIATE,
    MANAGE_AFP,
    BAN_USERS,
    UNBAN_USERS,
    WHITELIST_USERS,
    UNWHITELIST_USERS
]

exports.assignablePermissionKeys = exports.assignablePermissions.map(p => p.key);

// Goes through .includes and unpacks a role to a list of included roles
const unpackPermission = (permission) => {
    if (typeof exports[permission] === "undefined") return [];

    let unpackedPermissions = [permission];
    if (typeof exports[permission].includes === "undefined") return unpackedPermissions;

    for (let i = 0; i < exports[permission].includes.length; i++) {
        unpackedPermissions = unpackedPermissions.concat(unpackPermission(exports[permission].includes[i].key));
    }
    unpackedPermissions = [...new Set(unpackedPermissions)];
    return unpackedPermissions;
}
exports.unpackPermission = unpackPermission;

const unpackPermissions = (permissions) => {
    if (!permissions) return [];
    let unpackedPermissions = [];
    for (let i = 0; i < permissions.length; i++) {
        unpackedPermissions = unpackedPermissions.concat(unpackPermission(permissions[i]));
    }
    return unpackedPermissions;
}
exports.unpackPermissions = unpackPermissions;

const checkHasPermission = (requiredPermission, permissions) => {
    console.log("Checking permission", requiredPermission, "from permissions", permissions);
    if (!permissions || permissions.indexOf(requiredPermission.key) === -1) {
        throw new ProjectAccessDeniedError();
    }
    return true;
}
exports.checkHasPermission = checkHasPermission;

const unpackAndCheckPermission = (requiredPermission, permissions) => {
    if (!permissions) return false;
    return unpackPermissions(permissions).indexOf(requiredPermission.key) > -1;
}
exports.unpackAndCheckPermission = unpackAndCheckPermission;

exports.getUnpackedAndAssignablePermissionsOnly = (permissions) => {
    let unpackedPermissions = unpackPermissions(permissions);
    let autoIncludedPermissions = unpackedPermissions.filter(p => permissions.indexOf(p) === -1);
    autoIncludedPermissions = autoIncludedPermissions.filter(p => exports.assignablePermissionKeys.indexOf(p) > -1);
    return autoIncludedPermissions;
}

exports.getRolesFromUserPermissions = (userPermissionKeys) => {
    const userPermissionsSet = new Set(unpackPermissions(userPermissionKeys));

    let matchedRole = null;
    let matchedRolePermCount = 0;

    for (const role of exports.assignableRoles) {
        const rolePermissionKeys = unpackPermission(role.key);
        const rolePermissionSet = new Set(rolePermissionKeys);

        const hasAll = [...rolePermissionSet].every((perm) => userPermissionsSet.has(perm));

        if (hasAll) {
            if (rolePermissionSet.size > matchedRolePermCount) {
                matchedRole = role;
                matchedRolePermCount = rolePermissionSet.size;
            }
        }
    }

    return matchedRole;
}
